module.exports = __webpack_public_path__ + "static/media/DutchBucket1.54f4fa29.webp";